import { render, staticRenderFns } from "./studentMessageDetail.vue?vue&type=template&id=832196ba&scoped=true"
import script from "./studentMessageDetail.vue?vue&type=script&lang=js"
export * from "./studentMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./studentMessageDetail.vue?vue&type=style&index=0&id=832196ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832196ba",
  null
  
)

export default component.exports